import React from 'react'
import PropTypes from 'prop-types'
import {
    Box,
    Button,
    Link,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalOverlay
} from '@chakra-ui/react'
import {FormattedMessage} from 'react-intl'
import CMSContent from '../cms-content'

const RedirectLinkPartnerModal = ({
    isOpen,
    onClose,
    overlayAssetId,
    onClick,
    partnerBrandButtonColor,
    partnerBrand,
    onOpen,
    partnerLink
}) => (
    <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent backgroundColor="white">
            <ModalCloseButton />
            <ModalBody paddingX={8} paddingTop={16}>
                <Box maxW="100%" overflow="hidden" sx={{'& *': {maxWidth: '100%'}}}>
                    <CMSContent id={overlayAssetId} showError={false} />
                </Box>
            </ModalBody>
            <ModalFooter paddingBottom={8}>
                <Button
                    as={Link}
                    isExternal
                    href={partnerLink}
                    onClick={() => {
                        onOpen?.()
                        onClick?.()
                    }}
                    width="100%"
                    className="add-to-cart"
                    {...(partnerBrandButtonColor
                        ? {
                              bg: partnerBrandButtonColor,
                              borderColor: partnerBrandButtonColor,
                              _hover: {
                                  bg: partnerBrandButtonColor,
                                  color: 'white'
                              }
                          }
                        : {})}
                >
                    <FormattedMessage
                        id="partner_redirect.overlay.label"
                        defaultMessage="Continue to {partnerBrand}"
                        values={{partnerBrand}}
                    />
                </Button>
            </ModalFooter>
        </ModalContent>
    </Modal>
)

RedirectLinkPartnerModal.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    overlayAssetId: PropTypes.string,
    href: PropTypes.string,
    onClick: PropTypes.func,
    partnerBrandButtonColor: PropTypes.string,
    partnerBrand: PropTypes.string,
    onOpen: PropTypes.func,
    partnerLink: PropTypes.string
}

export default RedirectLinkPartnerModal
